export const SITE = {
  // Header
  headerWordmark: 'header-wordmark',
  navProducts: 'nav-products',
  navWhy: 'nav-why',
  navClients: 'nav-clients',
  navContact: 'nav-contact',
  langToggle: 'lang-toggle',
  headerCta: 'header-cta',

  // Hero
  heroSection: 'hero-section',
  heroCtaPrimary: 'hero-cta-primary',
  heroCtaSecondary: 'hero-cta-secondary',

  // Products
  productsSection: 'products-section',
  productCard: (slug) => `product-card-${slug}`,

  // Manifesto (Why Mads)
  whySection: 'why-section',
  whyChapter: (n) => `why-chapter-${n}`,

  // Clients
  clientsSection: 'clients-section',
  clientLogo: (i) => `client-logo-${i}`,

  // Contact
  contactSection: 'contact-section',
  contactForm: 'contact-form',
  contactName: 'contact-name',
  contactCompany: 'contact-company',
  contactEmail: 'contact-email',
  contactPhone: 'contact-phone',
  contactBrief: 'contact-brief',
  contactSubmit: 'contact-submit',
  contactSuccess: 'contact-success',
  contactError: 'contact-error',

  // Footer
  footerSection: 'footer-section',
};
